import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { Helmet } from 'react-helmet';

const About = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    title: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userID = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs.send(serviceID, templateID, formData, userID)
      .then(() => {
        setSubmitted(true);
        setLoading(false);
      })
      .catch((err) => {
        setError('Failed to send message. Please try again later.');
        setLoading(false);
        console.error('EmailJS error:', err);
      });
  };

  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-900 dark:text-gray-100">
      <Helmet>
        <title>About Imagera - Empowering Digital Artists</title>
        <meta
          name="description"
          content="Learn more about Imagera — a platform to share, like, and earn coins through digital artwork."
        />
      </Helmet>

      <button
        onClick={() => navigate('/')}
        className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Back to Home"
      >
        ← Back to Home
      </button>

      <h1 className="text-4xl font-extrabold mb-6">About Us</h1>

      <section className="mb-10 space-y-4">
        <p>
          Welcome to <strong>Imagera</strong>! We’re passionate about connecting
          creators and enthusiasts through a vibrant community. Our mission is to empower artists
          and share creativity worldwide.
        </p>
        <p>
          This platform allows you to share your artwork, gain followers, earn coins for likes,
          and redeem those coins for real rewards. We are constantly improving and
          appreciate your feedback.
        </p>
        <p>
          Ready to showcase your talent? <a href="/create-pin" className="text-blue-600 underline">Upload your artwork</a> now and start earning coins!
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        {submitted ? (
          <p className="text-green-600 dark:text-green-400 font-semibold">
            Thank you for reaching out! We will get back to you soon.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6 max-w-md">
            <div>
              <label htmlFor="name" className="block mb-1 font-medium">
                Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full rounded border border-gray-300 dark:border-gray-700 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-gray-100"
                placeholder="Your full name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block mb-1 font-medium">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full rounded border border-gray-300 dark:border-gray-700 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-gray-100"
                placeholder="you@example.com"
              />
            </div>

            <div>
              <label htmlFor="message" className="block mb-1 font-medium">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                required
                value={formData.message}
                onChange={handleChange}
                className="w-full rounded border border-gray-300 dark:border-gray-700 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-gray-100"
                placeholder="Write your message here..."
              />
            </div>

            <p className="text-sm text-gray-600 dark:text-gray-400">
              By submitting this form, you consent to the storage and processing of your data to contact you.
              Read our <a href="/privacy-policy" className="text-blue-600 underline">Privacy Policy</a>.
            </p>

            {error && <p className="text-red-600 dark:text-red-400">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className={`${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                } text-white px-6 py-2 rounded font-semibold transition`}
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">Our Location</h2>
        <p>Shree Nagar Society, Idar, SK, Gujarat</p>
        <p>
          Email: <a href="mailto:hitarth0236@gmail.com" className="text-blue-600 underline">hitarth0236@gmail.com</a>
        </p>
        <p>Phone: +1 (234) 567-8901</p>
      </section>
    </div>
  );
};

export default About;